import { useDocs } from '@cdn/docs';
import { useI18n, Locale } from '@cdn/i18n';
import { Select } from '@cdn/ui';
import styles from './styles.module.css';
import { useTheme } from './theme-context';

/**
 * Persistent language selector. Language names are shown in their own language so they can be found by
 * someone who does not read the current one.
 */
export function LanguageSelector() {
	const { t, locale } = useI18n();
	return (
		<label className="flex items-center gap-2 text-sm text-muted">
			<span className="sr-only">{t('shell.language.label')}</span>
			<Select value={locale.code} onChange={event => locale.select(event.target.value)} aria-label={t('shell.language.label')}>
				{Locale.supported.map(code => (
					<option key={code} value={code} lang={code}>
						{t(`shell.language.${code}`)}
					</option>
				))}
			</Select>
		</label>
	);
}

export function ThemeToggle() {
	const { t } = useI18n();
	const theme = useTheme();
	return (
		<button type="button" className={styles.tool} aria-pressed={theme.mode === 'dark'} onClick={() => theme.toggle()}>
			{t(theme.mode === 'dark' ? 'shell.theme.light' : 'shell.theme.dark')}
		</button>
	);
}

/**
 * Links to the one canonical public documentation and to Beyond Landing, in the selected language
 */
export function PublicLinks() {
	const { t, locale } = useI18n();
	const docs = useDocs();
	return (
		<>
			<a className={styles.tool} href={docs.page('cdn', locale.code)} target="_blank" rel="noreferrer">
				{t('shell.links.docs')}
			</a>
			<a className={styles.tool} href={docs.landing(locale.code)} target="_blank" rel="noreferrer">
				{t('shell.links.landing')}
			</a>
		</>
	);
}
